import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import { getDataAtual, getDataFormatada, getData, getDataBanco, getDataHoraBanco, getDataHoraFormatada } from '../utils/dataUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PESAGEM_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = { data_pesagem: getDataAtual() }) {
    return [
        initialize('pesagemForm', {
			...registro,
			data_pesagem: getDataHoraFormatada(registro.data_pesagem, 'DD/MM/YYYY')
		})
    ];
}

export function getLista(id_empresa) {
    const request = axios.get(`${consts.API_URL}/pesagem?id_empresa=${id_empresa}`);
    return {
        type: 'PESAGEM_LISTADO',
        payload: request
    };
}

export function getListaGranja(id_empresa) {
    const request = axios.get(`${consts.API_URL}/granja/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'PESAGEM_GRANJA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaLote(id_empresa) {
    const request = axios.get(`${consts.API_URL}/lote/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'PESAGEM_LOTE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaAnimal(id_empresa) {
    const request = axios.get(`${consts.API_URL}/animal/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'PESAGEM_ANIMAL_SELECT_LISTADO',
        payload: request
    };
}

export function salvar(registro) {

    return (dispatch, getState) => {
        axios.post(`${consts.API_URL}/pesagem`, {
			...registro,
			id_empresa: getState().auth.usuario.id_empresa,
			data_pesagem: getDataBanco(registro.data_pesagem),
			id_granja: registro.id_granja == '0' ? null : registro.id_granja,
			id_lote: registro.id_lote == '0' ? null : registro.id_lote,
			id_animal: registro.id_animal == '0' ? null : registro.id_animal,
			id_produto: registro.id_produto == '0' ? null : registro.id_produto
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(getState().auth.usuario.id_empresa));
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pesagem?id=${registro.id}`)
            .then(resp => {
                setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(getState().auth.usuario.id_empresa));
                dispatch(setModoTela('lista'));
            })
            .catch(e => {
                setErroAPI(e);
            });
    };
}
